import React, { Component } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Row, Col } from 'reactstrap';
import ImageAndPDFViewer from "../../components/ImageAndPDFViewer/ImageAndPDFViewer";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;


class AddOfftakeEntryLeftPan extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      scale: 1,
      imageWidth: 570,
      imageHeight: 590
    };
  }

  openViewModal = (data) => {
    this.refs.openViewModal.toggle(data);
  }

  zoomInPDF = () => {
    let { scale } = this.state;
    if (scale > 3) {
      return;
    }

    scale += 0.5;
    this.setState({ scale });
  }

  zoomOutPDF = () => {
    let { scale } = this.state;
    if (scale <= 1) {
      return;
    }
    scale -= 0.5;
    this.setState({ scale });
  }

  zoomInImage = () => {
    let { imageWidth, imageHeight } = this.state;

    if (imageWidth > 1300) {
      return;
    }

    imageWidth += 100;
    imageHeight += 100;
    this.setState({ imageWidth, imageHeight });
  }

  zoomOutImage = () => {
    let { imageWidth, imageHeight } = this.state;
    if (imageWidth <= 570) {
      return;
    }
    imageWidth -= 100;
    imageHeight -= 100;
    this.setState({ imageWidth, imageHeight });
  }

  render() {
    const { pageNumber, scale } = this.state;
    const { uploadedFile } = this.props;
    return (
      <div>
        {
          this.props.from !== 'editOfftakeEntry' &&
          <>
            <Row>
              <Col>
                <span className="custom-link" onClick={this.props.openFileBox}>
                  {
                    '+ Upload Invoice'
                    // uploadedFileData.name ? '+ Modify Invoice' : '+ Upload Invoice'
                  }
                </span>
                {/* <Button className="mb-1 mr-1 btn-pill action-button profile-save-button" color="warning" style={{ width: '171px' }} onClick={this.props.openFileBox}>Upload Invoice</Button> */}
              </Col>
            </Row>


            <Row style={{ marginTop: '15px' }}>
              <Col className="fm-instruction">
                Note: Please upload only valid invoices, received from JK Authorized dealers.
                Other documents like challan, tyre purchase lists are considered invalid.
                <br />
                Click on image to view larger image.
              </Col>
            </Row>
          </>
        }

        {
          this.props.from === 'editOfftakeEntry' &&
          <>
            <Row style={{ marginTop: '15px' }}>
              <Col className="fm-instruction">
                Note: Click on image to view larger image.
              </Col>
            </Row>
          </>
        }

        <Row>
          {
            uploadedFile.map((uploadedFileData, index) => (
              uploadedFileData.url ?
                <>
                  {
                    uploadedFileData.type === 'pdf' &&
                    <>
                      <Col xl="3" md="3" sm="6" xs="12" id='pdf-disp' style={{ marginTop: '20px', paddingRight: '10px', paddingLeft: '10px' }}>
                        <div style={{ border: '1px solid #b9b7b7', borderRadius: '20px', height: '140px', textAlign: 'center', position: 'relative' }}>

                          <img src="images/delete.svg" alt='delete' className="cursor-pointer edit-delete-icon"
                            onClick={() => this.props.deleteInvoice(uploadedFileData)}
                            style={this.props.from === '' ? { position: 'absolute', right: '10px', top: '10px' } : { visibility: 'hidden' }} />

                          <Document
                            file={uploadedFileData.url}
                            onLoadSuccess={this.onDocumentLoadSuccess}
                            loading="Loading..."
                            
                            onClick={() => this.openViewModal(uploadedFileData)}
                          // className="react-pdf"
                          >
                            <Page pageNumber={pageNumber} width="65" scale={scale} />
                          </Document>

                        </div>
                      </Col>
                    </>
                  }

                  {
                    uploadedFileData.type !== 'pdf' &&
                    <>
                      <Col xl="3" md="3" sm="6" xs="12" style={{ overflow: 'auto', marginTop: '20px', paddingRight: '10px', paddingLeft: '10px' }}>

                        <div style={{ border: '1px solid #b9b7b7', borderRadius: '20px', height: '140px', textAlign: 'center', position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                          <img src="images/delete.svg" alt='delete' className="cursor-pointer edit-delete-icon"
                            onClick={() => this.props.deleteInvoice(uploadedFileData)}
                            style={this.props.from === '' ? { position: 'absolute', right: '10px', top: '10px' } : { visibility: 'hidden' }} />

                          <img src={uploadedFileData.url} alt={uploadedFileData.name} className="img-viewer" onClick={() => this.openViewModal(uploadedFileData)} style={{ maxWidth: '90%', maxHeight: '90%' }} />

                        </div>

                      </Col>
                    </>
                  }
                </>
                :
                ''
            ))
          }
        </Row>

        <ImageAndPDFViewer
          title="Invoice"
          ref="openViewModal"
        />

        {/*  {
          uploadedFile.map((uploadedFileData, index) => (
            uploadedFileData.url ?
            <>
              {
                uploadedFileData.type === 'pdf' &&
                <>
                  <Row style={{ marginTop: '15px' }}>
                    <Col xl="10" md="10" sm="8" xs="8">
                      <span className="invoice-1jpg">
                      </span>
                    </Col>
                    <Col>
                      <div className="pull-right">
                        <FontAwesomeIcon onClick={this.zoomInPDF} icon={faPlusCircle} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
                        &nbsp;&nbsp;
                        <FontAwesomeIcon onClick={this.zoomOutPDF} icon={faMinusCircle} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
                      </div>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '12px', overflow: 'auto' }}>
                    <Col>
                      <Document
                        file={uploadedFileData.url}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                        loading="Loading..."
                        className="react-pdf"
                      >
                        <Page pageNumber={pageNumber} width="500" height="500" scale={scale} />
                      </Document>
                    </Col>
                  </Row>
                </>
              }

              {
                uploadedFileData.type !== 'pdf' &&
                <>
                  <Row style={{ marginTop: '15px' }}>
                    <Col xl="10" md="10" sm="8" xs="8">
                      <span className="invoice-1jpg">
                      </span>
                    </Col>
                    <Col>
                      <div className="pull-right">
                        <FontAwesomeIcon onClick={this.zoomInImage} icon={faPlusCircle} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
                        &nbsp;&nbsp;
                        <FontAwesomeIcon onClick={this.zoomOutImage} icon={faMinusCircle} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
                      </div>
                    </Col>
                  </Row>
                  <Row style={{ overflow: 'auto', maxWidth: '570px' }}>
                    <Col>
                      <img src={uploadedFileData.url} alt={uploadedFileData.name} width={imageWidth} height={imageHeight} className="img-viewer" />
                    </Col>
                  </Row>
                </>
              }
            </>
            :
            ''
          ))
          
        } */}

      </div>
    );
  }
}

export default AddOfftakeEntryLeftPan;